import React, { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { getBarangayBySlug } from '../services/barangayService'
import BarangayHero from '../components/barangay/BarangayHero'
import BarangayAbout from '../components/barangay/BarangayAbout'
import BarangayVisionMission from '../components/barangay/BarangayVisionMission'
import BarangayGoalsObjectives from '../components/barangay/BarangayGoalsObjectives'
import BarangayContact from '../components/barangay/BarangayContact'
import BarangayFooter from '../components/barangay/BarangayFooter'

const BarangayProfile = () => {
  const { slug } = useParams()
  const navigate = useNavigate()
  const [barangay, setBarangay] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchBarangay = async () => {
      try {
        setLoading(true)
        setError(null)

        const data = await getBarangayBySlug(slug)

        if (!data) {
          // Barangay not found - redirect to 404
          navigate('/404', { replace: true })
          return
        }

        setBarangay(data)
      } catch (err) {
        console.error('Error loading barangay:', err)
        setError('Failed to load barangay information. Please try again later.')
      } finally {
        setLoading(false)
      }
    }

    fetchBarangay()
  }, [slug, navigate])

  if (loading) {
    return (
      <div className="preloader preloader-alt">
        <span className="spinner spinner-round"></span>
      </div>
    )
  }

  if (error) {
    return (
      <section className="section bg-white">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
              <h2 className="title">Error Loading Barangay</h2>
              <p className="lead">{error}</p>
            </div>
          </div>
        </div>
      </section>
    )
  }

  if (!barangay) {
    return null // Will redirect to 404
  }

  return (
    <>
      <BarangayHero barangay={barangay} />
      <BarangayAbout barangay={barangay} />
      <BarangayVisionMission barangay={barangay} />
      <BarangayGoalsObjectives barangay={barangay} />
      <BarangayContact barangay={barangay} />
      <BarangayFooter barangay={barangay} />
    </>
  )
}

export default BarangayProfile
